<div class="sticky-panel" *ngIf="panelClicked">
    <div class="row" style="padding: 8px;">
        <div class="col text-center pt-2">
            <h6 class="">Ta strona korzysta z ciasteczek aby świadczyć usługi na najwyższym poziomie. Dalsze korzystanie ze strony oznacza, że zgadzasz się na ich użycie.</h6>
        </div>
        <div class="col-2">
            <button class="btn btn-success" (click)="togglePanel()">Zatwierdz</button>
        </div>
    </div>
</div>